module.exports = __webpack_public_path__ + "img/triangle.01e59528.svg";